import { type PropsWithChildren, createContext, useContext } from 'react';

import type { AdminCandidatePageParams } from '@/app/admin/(authenticated)/candidate/page';
import { type useGetInterviewCandidateQuery } from '@/features/admin-candidate';
import { type QuestionAnswerDto } from '@/services/api';

export type DisplayMode = 'video' | 'general' | 'LOADING';

type PageAdminCandidateContextValue = AdminCandidatePageParams & {
  candidateQuery: ReturnType<typeof useGetInterviewCandidateQuery>;
  currentQuestion?: QuestionAnswerDto;
  handlePrevQuestion: () => void;
  handleNextQuestion: () => void;
  questionIdx: number;
  totalQuestionCount?: number;
  canGoNext: boolean;
  canGoPrev: boolean;
  displayMode: DisplayMode;
  setDisplayMode: (mode: DisplayMode) => void;
  isSupportAccount: boolean;
};

const PageAdminCandidateContext =
  createContext<PageAdminCandidateContextValue | null>(null);

export const usePageAdminCandidateContext = () => {
  const context = useContext(PageAdminCandidateContext);
  if (!context) {
    throw new Error(
      'usePageAdminCandidateContext must be used within a PageAdminCandidateProvider'
    );
  }
  return context;
};

export const PageAdminCandidateProvider: React.FC<
  PropsWithChildren<PageAdminCandidateContextValue>
> = ({ children, ...value }) => {
  return (
    <PageAdminCandidateContext.Provider value={value}>
      {children}
    </PageAdminCandidateContext.Provider>
  );
};
